import { gatewayIcon } from '../../Billing';
import { TopUpHistory } from '@src/services/topUp/topUpApiSliceTypes';
import { PaymentStatus } from '@src/types/payment';
import { PaymentResultBase } from './PaymentResultBase';
interface TopUpPaymentResultProps {
  topUpHistory: TopUpHistory;
  status?: PaymentStatus;
}

export function TopUpPaymentResult({
  topUpHistory,
  status,
}: TopUpPaymentResultProps) {
  return (
    <PaymentResultBase
      status={status}
      idLabel='Order ID:'
      idValue={topUpHistory.code}
      amount={Number(topUpHistory.price)}
      currency={topUpHistory.currency}
      time={topUpHistory.time}
      provider={
        topUpHistory.gateway &&
        gatewayIcon[topUpHistory.gateway.toLowerCase() || '']
      }
    />
  );
}
